<template>
	<div class="index">
		<van-nav-bar class="custom-nav-bar" :title="$t('activity.page_title')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>
		<div class="custom-tabbar-page">
			<div class="activity-tab-page">
				<div class="page-header">
					<div class="header-bg">
						<div class="header-icon">🎉</div>
						<div class="header-title">
							{{ $t('activity.exciting_activities') }}
						</div>
						<div class="header-subtitle">
							{{ $t('activity.exciting_activities_subtitle') }}
						</div>
					</div>
				</div>

				<div class="activity-section">
					<div class="section-header">
						<div class="header-line left"></div>
						<div class="header-content">
							<div class="section-icon"></div>
							<div class="section-title">{{ $t('activity.popular_activities') }}</div>
						</div>
						<div class="header-line right"></div>
					</div>

					<div class="activity-list" style="display: none;">
						<div class="activity-item">
							<div class="activity-card">
								<div class="activity-icon">
									<div class="icon-text">🎁</div>
								</div>

								<div class="activity-info">
									<div class="activity-title">{{ $t('activity.new_user_recharge_reward') }}</div>
									<div class="activity-desc">
										{{ $t('activity.view_details') }}
									</div>
								</div>

								<div class="activity-arrow">
									<span class="tn-icon-right"></span>
								</div>
							</div>
						</div>
					</div>
					
					<div class="empty-state">
						<div class="empty-icon">📭</div>
						<div class="empty-text">{{ $t('activity.no_activities') }}</div>
						<div class="empty-subtext">{{ $t('activity.more_activities_coming') }}</div>
					</div>
				</div>

				<div class="tn-tabbar-height"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		created() {
			
		},
		methods: {
			back() {
				return window.history.back();
			},
		},
	};
</script>

<style lang="less" scoped>
	.index {
		width: 100%;
		height: 100vh;
		position: relative;
		background-color: #f2f2f2;
	}

	.index .custom-tabbar-page {
		width: 100%;
		height: calc(100vh - 62px);
		box-sizing: border-box;
		padding-bottom: 0px;
		padding-bottom: calc(0px + constant(safe-area-inset-bottom));
		padding-bottom: calc(0px + env(safe-area-inset-bottom));
	}

	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 202px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px;
	}

	.network-error-bar {
		margin: 0 15px 10px;
		background: rgba(238, 90, 111, .08);
		border: 0.5px solid rgba(238, 90, 111, .3);
		border-radius: 8px;
		padding: 10px 12px
	}

	.network-error-text {
		font-size: 12px;
		color: #ee5a6f
	}

	.activity-tab-page {
		background: linear-gradient(180deg, #f8f9fa, #f2f2f5);
		min-height: 100vh
	}

	/* 页面头部 */
	.page-header {
		padding: 10px 15px
	}

	.page-header .header-bg {
		background: linear-gradient(135deg, #f093fb, #f5576c);
		border-radius: 12px;
		padding: 26px 20px;
		text-align: center;
		box-shadow: 0 4px 15px rgba(245, 87, 108, .3)
	}

	.page-header .header-bg .header-icon {
		display: block;
		font-size: 31px;
		margin-bottom: 8px
	}

	.page-header .header-bg .header-title {
		display: block;
		font-size: 22px;
		font-weight: 700;
		color: #fff;
		margin-bottom: 6px;
		letter-spacing: 2px
	}

	.page-header .header-bg .header-subtitle {
		display: block;
		font-size: 12px;
		color: hsla(0, 0%, 100%, .9);
		letter-spacing: 1px
	}

	/* 活动区域 */
	.activity-section {
		background: linear-gradient(135deg, #fff, #f8f9fa);
		margin: 10px;
		padding: 20px 15px;
		border-radius: 12px;
		box-shadow: 0 4px 15px rgba(0, 0, 0, .06);
		border: 0.5px solid rgba(245, 87, 108, .08)
	}

	.activity-section .section-header {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px
	}

	.activity-section .section-header .header-line {
		flex: 1;
		height: 1px;
		max-width: 41px
	}

	.activity-section .section-header .header-line.left {
		background: linear-gradient(90deg, transparent, #f5576c)
	}

	.activity-section .section-header .header-line.right {
		background: linear-gradient(270deg, transparent, #f5576c)
	}

	.activity-section .section-header .header-content {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 12px
	}

	.activity-section .section-header .header-content .section-icon {
		font-size: 18px;
		margin-right: 6px
	}

	.activity-section .section-header .header-content .section-title {
		font-size: 17px;
		font-weight: 700;
		color: #333;
		letter-spacing: 2px
	}

	/* 活动列表 */
	.activity-list .activity-item {
		margin-bottom: 12px;
		-webkit-animation: fadeInUp-data-v-4c371dba .5s ease forwards;
		animation: fadeInUp-data-v-4c371dba .5s ease forwards;
		opacity: 0;
		-webkit-transform: translateY(10px);
		transform: translateY(10px)
	}

	.activity-list .activity-item:last-child {
		margin-bottom: 0
	}

	.activity-list .activity-item .activity-card {
		display: flex;
		align-items: center;
		padding: 15px;
		background: linear-gradient(145deg, #fff, #f8f9fa);
		border-radius: 10px;
		box-shadow: 3px 3px 8px rgba(0, 0, 0, .06), -3px -3px 8px hsla(0, 0%, 100%, .8);
		transition: all .3s ease
	}

	.activity-list .activity-item .activity-card:active {
		-webkit-transform: scale(.98);
		transform: scale(.98);
		box-shadow: 1px 1px 5px rgba(0, 0, 0, .08), -1px -1px 5px hsla(0, 0%, 100%, .9)
	}

	.activity-list .activity-item .activity-card .activity-icon {
		width: 41px;
		height: 41px;
		background: linear-gradient(135deg, #f093fb, #f5576c);
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
		box-shadow: 0 2px 6px rgba(245, 87, 108, .3)
	}

	.activity-list .activity-item .activity-card .activity-icon .icon-text {
		font-size: 20px
	}

	.activity-list .activity-item .activity-card .activity-info {
		flex: 1
	}

	.activity-list .activity-item .activity-card .activity-info .activity-title {
		display: block;
		font-size: 15px;
		color: #333;
		font-weight: 600;
		margin-bottom: 4px
	}

	.activity-list .activity-item .activity-card .activity-info .activity-desc {
		font-size: 12px;
		color: #999
	}

	.activity-list .activity-item .activity-card .activity-arrow {
		width: 31px;
		height: 31px;
		background: rgba(245, 87, 108, .1);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	.activity-list .activity-item .activity-card .activity-arrow .tn-icon-right {
		font-size: 14px;
		color: #f5576c
	}

	/* 空状态 */
	.empty-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 52px 20px
	}

	.empty-state .empty-icon {
		font-size: 52px;
		margin-bottom: 12px
	}

	.empty-state .empty-text {
		font-size: 16px;
		color: #666;
		font-weight: 600;
		margin-bottom: 6px
	}

	.empty-state .empty-subtext {
		font-size: 13px;
		color: #999
	}

	@-webkit-keyframes fadeInUp-data-v-4c371dba {
		from {
			opacity: 0;
			-webkit-transform: translateY(10px);
			transform: translateY(10px)
		}

		to {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}
	}

	@keyframes fadeInUp-data-v-4c371dba {
		from {
			opacity: 0;
			-webkit-transform: translateY(10px);
			transform: translateY(10px)
		}

		to {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}
	}

	/* 底部安全边距 */
	.tn-tabbar-height {
		min-height: 62px;
		height: calc(72px + env(safe-area-inset-bottom) / 2);
		height: calc(72px + constant(safe-area-inset-bottom))
	}
</style>
